import { Component, OnInit } from '@angular/core';
import { AlienCheckOptions } from '../../models/alien-check-options.model';
import { Car } from '../../models/car.model';
import { CarService } from '../../services/car/car.service';
import { DisplayBlobService } from '../../shared/services/display-blob/display-blob.service';
import {AlienCheckFilterComponent} from "../../components/alien-check/alien-check-filter/alien-check-filter.component";
import {CarInfoBoxComponent} from "../../components/car-info-box/car-info-box.component";
import {TranslateModule} from "@ngx-translate/core";
import {
  AlienCheckStatusTableComponent
} from "../../components/alien-check/alien-check-status-table/alien-check-status-table.component";
import {PageHeaderComponent} from "../../shared/components/page-header/page-header.component";

@Component({
  selector: 'colimo-alien-check-page',
  templateUrl: './alien-check-page.component.html',
  styleUrls: ['./alien-check-page.component.scss'],
  imports: [
    AlienCheckFilterComponent,
    CarInfoBoxComponent,
    TranslateModule,
    AlienCheckStatusTableComponent,
    PageHeaderComponent
  ]
})
export class AlienCheckPageComponent implements OnInit {
  public alienCheckOptions: AlienCheckOptions;
  public car: Car;
  public isLoading: boolean;
  public heading: string;

  constructor(private carService: CarService, private displayBlobService: DisplayBlobService) {}

  public ngOnInit(): void {
    this.heading = 'reports.carCheck';
    this.alienCheckOptions = {
      location: null,
      color: null,
      carType: null,
      tolerancesOn: true,
      measurementFile: null,
    };
  }

  public uploadAndAlienCheck(): void {
    this.isLoading = true;
    // just to be sure that no old status is saved. Otherwise old data would be displayed while long taking requests.
    this.car = undefined;
    this.carService.uploadSingleCar(this.alienCheckOptions).subscribe((car: Car) => {
      this.car = car;
      this.isLoading = false;
    });
  }

  public exportAlienCheck(): void {
    this.carService.uploadSingleCarAndExportToExcel(this.alienCheckOptions).subscribe((blob: Blob) => {
      this.displayBlobService.displayBlob(blob, 'AlienReport.xlsx');
    });
  }
}
